import Build from "components/Champions/RecommendedBuild/Build";
import ArenaBuild from "components/Champions/RecommendedBuild/ArenaBuild";
import AramMayhemBuild from "@ugg/shared/components/TierList/pages/AramMayhem/AramMayhemTierListContainer";
import { useChampionProfileContext } from "@ugg/shared/components/Champions/ChampionProfileContext";
import { SPECIAL_CHAMPION_PAGES } from "@ugg/shared/pages/champion-pages";

export function Overview() {
  const { page } = useChampionProfileContext();

  if (page === SPECIAL_CHAMPION_PAGES.OVERVIEW_ARENA) {
    return <ArenaBuild />;
  }

  if (page === SPECIAL_CHAMPION_PAGES.OVERVIEW_ARAM_MAYHEM) {
    return <AramMayhemBuild />;
  }

  return <Build />;
}
